var React = require('react');

function NpRectangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M95.7754 24C95.7754 37.2548 85.0302 48 71.7754 48L-35.4372 48C-48.692 48 -59.4372 37.2548 -59.4372 24C-59.4372 10.7451 -48.6921 -1.26297e-05 -35.4372 -1.1471e-05L71.7753 -2.09815e-06C85.0302 -9.39375e-07 95.7754 10.7452 95.7754 24Z"}));
}

NpRectangle.defaultProps = {"width":"96","height":"48","viewBox":"0 0 96 48"};

module.exports = NpRectangle;

NpRectangle.default = NpRectangle;
